import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { useMemo, useRef } from 'react';
import { useIntersectionObserver } from '../../../hooks/useIntersectionObserver';
import { getAccountDashboardUrl } from '../../../utils/urls';
import { getTrackingProperties, track } from '../../../utils/usageTracker';
import { ErrorBoundary, ErrorBoundaryNames } from '../../ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
const ViewAccountButtonBase = ({
  'data-selenium-id': dataSeleniumId,
  'data-test-id': dataTestId,
  apiName,
  children,
  trackingData,
  upgradeConfig,
  uiButtonProps,
  onClick
}) => {
  const trackingProperties = useMemo(() => getTrackingProperties({
    apiName,
    trackingData,
    upgradeConfig,
    sourceKey: 'VIEW_ACCOUNT'
  }), [apiName, trackingData, upgradeConfig]);
  const internalRef = useRef(null);
  const buttonRef = (uiButtonProps === null || uiButtonProps === void 0 ? void 0 : uiButtonProps.buttonRef) || internalRef;
  useIntersectionObserver({
    targetRef: buttonRef,
    onIntersect: () => {
      track('interaction', Object.assign({
        action: 'viewed view account'
      }, trackingProperties));
    }
  });
  const handleClick = () => {
    onClick === null || onClick === void 0 || onClick('VIEW_ACCOUNT');
    track('external-link-click', {
      name: 'account-summary',
      trackingSource: trackingData.source
    });
  };
  return /*#__PURE__*/_jsx(Button, Object.assign({
    "data-selenium-id": dataSeleniumId,
    "data-test-id": dataTestId,
    href: getAccountDashboardUrl(),
    target: "_blank",
    truncate: true,
    truncateStringProps: {
      justifyContent: 'center'
    },
    onClick: handleClick
  }, uiButtonProps, {
    // TODO: remove cast when on React 19 types (HubSpotEngineering/fefw#73)
    buttonRef: buttonRef,
    children: children !== null && children !== void 0 ? children : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "purchaseMotions.buttons.viewAccount"
    })
  }));
};
export const ViewAccountButton = props => /*#__PURE__*/_jsx(ErrorBoundary, {
  boundaryName: ErrorBoundaryNames.VIEW_ACCOUNT_BUTTON,
  children: /*#__PURE__*/_jsx(ViewAccountButtonBase, Object.assign({}, props))
});